import React from 'react';
import { Lightbulb } from 'lucide-react';
export function Process() {
  const steps = [{
    num: '1',
    title: 'Request a Commercial Estimate',
    copy: 'Submit the short form or call Kosin’s Glass.'
  }, {
    num: '2',
    title: 'Share Project Details',
    copy: 'A team member will ask about your company, project address, glass type, photos, measurements, drawings, project timeline and bid requirements.'
  }, {
    num: '3',
    title: 'Scope Review & Field Measurement',
    copy: 'For approved projects, Kosin’s Glass reviews the scope, confirms measurements and identifies repair, replacement, fabrication or glazing requirements.'
  }, {
    num: '4',
    title: 'Fabrication, Ordering & Scheduling',
    copy: 'Your glass, hardware or glazing system is prepared, ordered or fabricated, then scheduled around your building, tenant or construction timeline.'
  }, {
    num: '5',
    title: 'Professional Installation or Service',
    copy: 'Experienced commercial glass technicians complete the installation, repair, replacement or maintenance work with attention to safety, quality and the project schedule.'
  }];
  return <section className="py-20 bg-slate-50 border-t border-slate-200" data-id="element-762" data-mp="3j439slud0981">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-763" data-mp="3o1wf7cnu8z79">
        <div className="text-center mb-16 anim-on-scroll" data-id="element-764" data-mp="3o1d4afwlvb2q">
          <h2 className="kosins-heading text-4xl md:text-5xl text-neutral-900" data-id="element-765" data-mp="2qf5tupdmeoig">
            How Your Commercial Glass Quote Works
          </h2>
          <p className="mt-4 text-base text-neutral-600 max-w-2xl mx-auto font-sans italic" data-id="element-766" data-mp="2vbeegial79x0">
            Property managers, builders and business owners rely on Kosin's
            Glass for clear scope review, accurate measurements and professional
            installation.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-12 items-start" data-id="element-767" data-mp="27m26tmuwr9wt">
          <div className="lg:col-span-8" data-id="element-768" data-mp="2clogxnffwa1e">
            <div className="space-y-8" data-id="element-769" data-mp="24ma5ls3fbg3h">
              {steps.map((step, idx) => <div key={idx} className="flex gap-6 relative anim-on-scroll" data-id="element-770" data-mp="24k77slw14io7" data-mpi={idx}>
                  {/* Connecting Line */}
                  {idx !== steps.length - 1 && <div className="absolute left-6 top-14 bottom-[-2rem] w-0.5 bg-slate-200" data-id="element-771" data-mp="2eblbl5v0k4n5"></div>}
                  <div className="w-12 h-12 rounded-full bg-primary-600 text-white font-bold text-xl flex items-center justify-center shrink-0 relative z-10 shadow-md" data-id="element-772" data-mp="29f38sbj8ugdg">
                    {step.num}
                  </div>
                  <div className="pt-2 pb-4" data-id="element-773" data-mp="1vllqeu2an9p0">
                    <h3 className="kosins-heading text-2xl text-neutral-900 mb-2" data-id="element-774" data-mp="1vmen127jgitf">
                      {step.title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed" data-id="element-775" data-mp="1qov7lyz3tzzw">
                      {step.copy}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="lg:col-span-4 anim-on-scroll" data-id="element-776" data-mp="nu6dvpy4gknb">
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-8 sticky top-8" data-id="element-777" data-mp="nslg7rgigll8">
              <div className="flex items-center gap-3 mb-4" data-id="element-778" data-mp="suastbjdt7bf">
                <Lightbulb className="w-6 h-6 text-amber-600" data-id="element-779" data-mp="eu03icxq00sd" />
                <h4 className="text-lg font-bold text-amber-900" data-id="element-780" data-mp="jsbamfwmrx6w">
                  Tip for a Faster Quote
                </h4>
              </div>
              <p className="text-amber-800 leading-relaxed text-sm" data-id="element-781" data-mp="17iyodht89h1d">
                For a faster quote, send clear photos, rough opening dimensions,
                project location, desired timeline and any available drawings or
                bid documents.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}